import React from 'react'
import {Box} from 'grommet'
import CreateShipmentLayout from '../../components/createShipmentLayout'
import {PieceDetailsCheck,ReturnQuote,ShipmentDetails,NavigationSnackBar} from '../../components/utils/shared/shared'
import NewShipmentRequest from '../../components/utils/newShipmentRequest.json'
import InitialCommodity from '../../components/utils/commodity.json'
import moment from 'moment'
import { API,Auth } from 'aws-amplify';
import ShipmentSummary from '../../components/shipmentSummary';
import ShipmentDetailsForm from '../../components/shipmentDetailsForm'
import ShipmentLocationCard from '../../components/shipmentLocationCard'
import { css } from 'styled-components';
import { Grommet } from 'grommet';
import { theme } from '../../components/theme';
import { deepMerge } from 'grommet/utils';


class CreateShipment extends React.Component {

  componentDidMount(){
    if (this.props.location.origin && this.props.location.destination){
      this.resetShipmentDetails(this.props.location.details)
      this.setState({origin: this.props.location.origin, destination: this.props.location.destination, quoteReady: true})
      this.requestQuote()
    }  
  }

  returnInitialLocation(props, locationType){
    if(props.location.origin && locationType === 'origin') {
      props.location.origin.primary_contact_person = props.location.origin.contact.contactName
      props.location.origin.primary_contact_email =  props.location.origin.contact.contactEmail
      props.location.origin.primary_contact_phone = props.location.origin.contact.contactPhone
      props.location.origin.id = props.location.origin.locationId
      props.location.origin.tax_id = props.location.origin.taxID
      props.location.origin.vat_number = props.location.origin.vatNumber
      props.location.origin.eori_number = props.location.origin.eoriNumber
      this.setState({origin: props.location.origin})
      return props.location.origin
    } else if (locationType === 'origin') {
      return { name: 'Select Origin Lab', contact:{ contactName: "",companyName: "",contactPhone: "",contactEmail: ""},address_line_one: "",address_line_two: "",address_line_three: "",country: {CountryCode: "", CountryName: ""},city: "",PostCode: "", postcode:""}
    } else if (props.location.destination && locationType === 'destination'){
      props.location.destination.primary_contact_person = props.location.destination.contact.contactName
      props.location.destination.primary_contact_email =  props.location.destination.contact.contactEmail
      props.location.destination.primary_contact_phone = props.location.destination.contact.contactPhone
      props.location.destination.tax_id = props.location.destination.taxID
      props.location.destination.vat_number = props.location.destination.vatNumber
      props.location.destination.eori_number = props.location.destination.eoriNumber
      this.setState({destination: props.location.destination})
      return props.location.destination
    } else {
      return { name: 'Select Destination Lab', Contact:{contactName: "",companyName: "",contactPhone: "",contactEmail: ""},address_line_one: "",address_line_two: "",address_line_three: "",country: {CountryCode: "", CountryName: ""},city: "",PostCode: "",postcode: ""}
    }
  }

  returnCustomerPO(username){
   if (username === 'iluminada.moreno@bureauveritas.com'){
     return `AGGREKO_${moment().format("YYYY-DD-MM")}`
   } else if (username === 'ops.eu@petro-inspect.com'){
     return `Sample_${moment().format("YYYY-DD-MM")}`
  } else {
     return ""
   }
  }

  returnCustomsValue(username){
    if (username === 'iluminada.moreno@bureauveritas.com' || username === 'ops.eu@petro-inspect.com'){
      return 1
    } else {
      return ""
    }
   }

  switchLocations = () => {
    this.setLocation(this.state.destination, 'origin')
    this.setLocation(this.state.origin, 'destination')
  }
  
  returnInitialCommodity = (user) => {
    if (user === 'Agent'){
      return InitialCommodity
    } else {
      return {}
    }
  }
  returnInitalDimension = (username) => {
    if (username === 'ops.eu@petro-inspect.com'){
      return 10
    } else{
      return ""
    }
  }
  state = {
    shipmentResponse: null,
    quoteReady: false,
    quoteLoad: false,
    firstQuote: true,
    origin: this.returnInitialLocation(this.props, 'origin'), 
    load: false,
    value: {customerPO: this.returnCustomerPO(this.props.username), dgMsds: "",requestPickup: true,pickupCloseTime:"17:00", collectionTime:moment().minute(Math.ceil(moment().minute() / 15) * 15).format("HH:mm"), collectionDate: new Date().toISOString(), commodity: this.returnInitialCommodity(this.props.user),dg:false},
    quote: null,
    showLayer:false,
    error: false,
    dgMsds:"",
    shipmentPieceDetails: [{commodity: this.returnInitialCommodity(this.props.user),weight: 0.5, length: this.returnInitalDimension(this.props.username), width: this.returnInitalDimension(this.props.username), height: this.returnInitalDimension(this.props.username), customsValue: this.returnCustomsValue(this.props.username), pieceRef: this.returnCustomerPO(this.props.username)}],
    destination: this.returnInitialLocation(this.props, 'destination'),
    shipmentNotifications: false,
    timeWarning: false,
  }

 
  


  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.replace("data:", "").replace(/^.+,/, "")) 
    reader.onerror = error => reject(error);
  });

  setShowLayer = (boolean) => {
    this.setState({showLayer: boolean})
  }

  handleValueChange = (e) => {
    this.setState({value: e})
  }

  handleDocsChange = (event) => {
    this.setState({dgMsds: event.target.files[0]})
  };


  setShipmentNotifications = () => {
    this.setState(prevState => ({
      shipmentNotifications: !prevState.shipmentNotifications
    }));
  }

  handlePieceDetails = (e, index) => {
    const list = [...this.state.shipmentPieceDetails]
    list[index] = e
    this.setState({shipmentPieceDetails: list});
    var quoteReady = PieceDetailsCheck(list, this.state.firstQuote)
    this.setState({quoteReady: quoteReady})
    if (quoteReady && this.state.firstQuote){
      this.requestQuote(true, list)
    }
  };

  handleRemovePieceClick = index => {
    const list = [...this.state.shipmentPieceDetails];
    list.splice(index, 1);
    this.setState({shipmentPieceDetails: list});
  };
 
  // handle click event of the Add button
   handleAddPieceClick = () => {
    var pieces = this.state.shipmentPieceDetails
    this.setState({shipmentPieceDetails: [...this.state.shipmentPieceDetails,pieces.pop()]});
  };
  
  resetShipmentDetails = (fields) => {
    var update = this.state.value
    var pieceDetails = []
    update.requestPickup = fields.RequestPickup;
    update.pickupCloseTime = fields.PickupCloseTime;
    update.pickupLocation = fields.PickUpLocation;
    update.customerPO = fields.CustomerPO
    update.dg = fields.DangerousGoods
    fields.Packages.forEach(item => {
        var piece = {commodity: {id: item.CommodityID, code: item.CommodityCode, name: item.Commodity, display_name: item.name, description: item.ItemDescription},weight:item.GrossWeight, length: item.Dimensions.Length, height: item.Dimensions.Height, width: item.Dimensions.Width, customsValue: item.CustomsValue, pieceRef: item.PieceReference}
        pieceDetails.push(piece)
    })
    this.setState({value:update, shipmentPieceDetails: pieceDetails})
  }

  handleSubmit = (e) => {
    this.setState({load: true, showLayer:false})
    NewShipmentRequest.shipment.origin = this.state.origin
    NewShipmentRequest.shipment.destination = this.state.destination
    NewShipmentRequest.shipment.notifications = this.state.shipmentNotifications
    NewShipmentRequest.shipment.pieces.DangerousGoods = this.state.value.dg    
    console.log(NewShipmentRequest)
    if (this.state.value.dg){
      this.toBase64(this.state.dgMsds).then(res => {
        NewShipmentRequest.shipment.pieces.DangerousGoodsMSDS = res
        Auth.currentSession().then(session => {
          API
          .post("LabShip", `/shipments`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:NewShipmentRequest})
          .then(shipment => {
           this.setState({load: false})
           var base_url = (this.props.user === 'SuperAdmin' ? '/admin': "")
            this.props.history.push({
              pathname: `${base_url}/dashboard`,
              dgNotification: true
            })
         })
        })
      })
    } else {
      Auth.currentSession().then(session => {
        API
        .post("LabShip", `/shipments`,
        { headers: { 
          Authorization: session.idToken.jwtToken,
        }, 
        body:NewShipmentRequest})
        .then(shipment => {
         this.setState({load: false})
         if (shipment.status === 'success'){
          this.props.history.push({
            pathname: '/shipment/success',
            state: { shipment: shipment,pieceDetails: this.state.value }
          })
         } else {
          this.props.history.push({
            pathname: '/shipment/fail',
            state: { shipment: shipment, pieceDetails: this.state.value }
          })
         }
         }).catch(err => {
          console.log(err)
          this.props.history.push({
            pathname: '/shipment/fail',
            state: {error: true }
          })
       })
      })
    }
    
  }

  requestQuote = (bool, dims) => {
    this.setState({quoteLoad: true, firstQuote: false})
    var quote = (bool ? ReturnQuote(this.state.value, dims, this.state.origin,this.state.destination) : ReturnQuote(this.state.value, this.state.shipmentPieceDetails,this.state.origin, this.state.destination))
    Auth.currentSession().then(session => {
      API
        .post("LabShip", `/quotes`,
        { headers: { 
          Authorization: session.idToken.jwtToken,
        }, 
        body: {quote: quote}
       }).then(quote => {
        this.setState({quoteLoad: false, quote: quote})
       }).catch(err => {
        this.setState({error: true, quoteLoad:false})
         console.log(err)
       })
      })
    }


  handleDestinationType = (e) => {
    this.setState({destinationType: e})
  }

  handleCustomOriginToggle = (e) => {
    this.setState({customOriginChecked: e.target.checked})
  }

  handleCustomDestinationToggle = (e) => {
    this.setState({customDestinationChecked: e.target.checked})
  }

  setLocation = (location,label) => {
    var update = location;
    update.contact = {}
    update.name = location.name
    update.address_line_one = location.address_line_one
    update.address_line_two = location.address_line_two
    update.address_line_three = location.address_line_three
    update.city = location.city
    update.county = location.county
    update.postcode = location.postcode
    update.country = location.country
    update.contact.contactName = location.primary_contact_person
    update.contact.companyName = location.name
    update.contact.contactPhone = location.primary_contact_phone
    update.contact.contactEmail = location.primary_contact_email
    update.EORINumber = location.eori_number
    update.VATNumber = location.vat_number
    update.TaxID = location.tax_id
    if (label === 'origin'){
      this.setState({origin: update})
     } else {
      this.setState({destination: update})
     } 
  }

  

  render(){
    const customTheme = deepMerge(theme, {
      global: {
        icon: {
          color:'brand'
        },
      },
    
  tab: {
    active: {
      background: 'brand',
      color: 'accent-1',
    },
    border: undefined,
    hover: {
      background: '#b4d8eb'
    },
    margin: undefined,
    pad: {
      bottom: undefined,
      horizontal: 'small',
    },
    extend: ({ theme }) => css`
      border-radius: 4px;
      /* or 'border-radius: ${theme.global.control.border.radius}' */
      box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.5);
      /* or 'box-shadow: ${theme.global.elevation.light.small}' */
    `,
  },
  tabs: {
    gap: 'small',
    header: {
      extend: ({ theme }) => css`
        padding: 10px;
        /* or 'padding: ${theme.global.edgeSize.small}' */
         'box-shadow: ${theme.global.elevation.light.medium}'
      `,
    },
  },
});

  function returnPages(user){
    if (user === 'Agent'){
      return []
    } else {
      return [{name: 'Dashboard', link:'/dashboard'}]
    }
  } 
    const {error,quoteReady, showLayer, load,value, quote, quoteLoad, destinationType, shipmentPieceDetails, origin,destination,shipmentNotifications} = this.state;  
    return (
      <Grommet theme={customTheme}>
      <Box background='light-1'>
        <NavigationSnackBar title={'Create Shipment'} user={this.props.user} pages={returnPages(this.props.user)}  />
          <CreateShipmentLayout user={this.props.user} error={error} requestQuote={this.requestQuote} shipmentPieceDetails={shipmentPieceDetails} switchLocations={this.switchLocations} showQuote={this.props.displayQuote} contact={origin} collection={value} quoteReady={quoteReady} quote={quote} quoteLoad={quoteLoad} load={load} lab={this.props.lab} size={this.props.size} origin={<ShipmentLocationCard user={this.props.user} reship={this.props.location.reship} props={this.props} username={this.props.username} size={this.props.size} setLocation={this.setLocation} shipmentLocation={origin} destinationType={destinationType} locationUrl={""} locationType={'origin'} handleDestinationType={this.handleDestinationType}/>} destination={<ShipmentLocationCard reship={this.props.location.reship}  username={this.props.username} size={this.props.size} shipmentLocation={destination} locationType={'destination'} locationUrl={""} setLocation={this.setLocation}/>} shipmentSummary={<ShipmentSummary showQuote={this.props.displayQuote} size={this.props.size} quote={quote} load={quoteLoad} showLayer={showLayer} setShowLayer={this.setShowLayer} handleSubmit={this.handleSubmit} origin={origin} destination={destination} value={value} shipmentPieceDetails={shipmentPieceDetails} shipmentNotifications={shipmentNotifications} setShipmentNotifications={this.setShipmentNotifications}/>} shipmentDetailsForm={<ShipmentDetailsForm user={this.props.user}  handleDocsChange={this.handleDocsChange} size={this.props.size} quoteReady={quoteReady} quote={quote} quoteLoad={quoteLoad} setShowLayer={this.setShowLayer} requestQuote={this.requestQuote} origin={origin} destination={destination} handleAddPiece={this.handleAddPieceClick} handleRemovePiece={this.handleRemovePieceClick} handlePieceDetails={this.handlePieceDetails}  handleValueChange={this.handleValueChange} value={value} shipmentPieceDetails={shipmentPieceDetails} lab={this.props.lab} shipmentDetails={ShipmentDetails} load={load} handleSubmit={this.handleSubmit}/>}/>
  
      </Box>
      </Grommet>
    )
  }
  
}

export default CreateShipment
